/**
 * Service for authorization and authentication
 */
import useApi from '../utils/api';

class AuthService {
  #prefix = '/auth';

  login = (login, password, rememberMe) => {
    return useApi.post(`${this.#prefix}/login`, {
      login,
      password,
      rememberMe,
    });
  };

  loginAsUser = (id) => {
    return useApi.post(`${this.#prefix}/loginAsUser`, {
      id,
    });
  };

  forgotPassword = (email) => {
    return useApi.post(`${this.#prefix}/forgotPassword`, {
      email,
    });
  };

  resetPassword = (data) => {
    return useApi.post(`${this.#prefix}/resetPassword`, data);
  };

  checkTokenValid = (data) => {
    return useApi.post(`${this.#prefix}/checkTokenValid`, data);
  };

  register = (data) => {
    return useApi.post(`${this.#prefix}/register`, data);
  };

  registerCheck = (data) => {
    return useApi.post(`${this.#prefix}/registerCheck`, data);
  };

  /**
   * Fire-and-forget : persiste la tentative d'inscription dans
   * registration_drafts. Appelle au passage step 1 → step 2. Si KO,
   * l'inscription continue normalement (audit-only).
   */
  registerDraft = (data) => {
    return useApi.post(`${this.#prefix}/registerDraft`, data);
  };

  sendVerificationCode = (data) => {
    return useApi.post(`${this.#prefix}/sendVerificationCode`, data);
  };

  verifyPhoneNumber = (data) => {
    return useApi.post(`${this.#prefix}/verifyPhoneNumber`, data);
  };

  logout = () => {
    return Promise.resolve();
  };

  updateProfile = (data) => {
    return useApi.post(`${this.#prefix}/updateProfile`, data);
  }
}

export default new AuthService();
